import { v4 as uuidv4 } from 'uuid';
import { getBenefitsApiUrl } from '../selectors/selectors';
import { APPLICATION_JSON, CLIENT_ID } from '../constants/constants';

export default {
  fetch: ({
    hotelReferenceDetails, bookingDate, checkinDate, program, tripId, contractId, locale, channel,
    correlationId, partnerName, cardType,
  }, action, state) => {
    const request = {
      hotelReferenceDetails,
      bookingDate,
      checkinDate,
      program,
      tripId,
      contractId,
      partnerName,
      cardType,
    };
    return {
      url: `${getBenefitsApiUrl(state)}`,
      opts: {
        method: 'POST',
        credentials: 'include',
        headers: {
          Accept: APPLICATION_JSON,
          'Content-Type': APPLICATION_JSON,
          'x-client-id': CLIENT_ID,
          'x-correlation-id': correlationId || uuidv4(),
          'x-locale': locale,
          'x-user-agent': window.navigator.userAgent,
          'x-channel': channel,
        },
        body: JSON.stringify(request),
      },
    };
  },
};
